export default "__VITE_ASSET__xxoFuTCE__"